"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimUserRakeback = void 0;
const common_1 = require("../../../../common");
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const perpetual_1 = require("../../perpetual");
const anchor_1 = require("@project-serum/anchor");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const spl_token_1 = require("@solana/spl-token");
const claimUserRakeback = ({ programId, connection, addComputeUnits, accounts, optimistic, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: 6000 });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const [hadespinRakeback, hadespinRakebackBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.HADESPIN_RAKEBACK_PREFIX), accounts.user.toBuffer()], program.programId);
    const [hadespinRakebackVault, hadespinRakebackVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.HADESPIN_RAKEBACK_VAULT_PREFIX), accounts.user.toBuffer()], program.programId);
    const hadespinRakebackVaultTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(hadespinRakebackVault, constants_1.HADES_TOKEN_ADDRESS);
    const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.user, constants_1.HADES_TOKEN_ADDRESS);
    instructions.push(yield program.methods
        .claimUserRakeback()
        .accountsStrict({
        user: accounts.user,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        rakeback: hadespinRakeback,
        rakebackVault: hadespinRakebackVault,
        tokenMint: constants_1.HADES_TOKEN_ADDRESS,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        userTokenAccount: userTokenAccount,
        rakebackVaultTokenAccount: hadespinRakebackVaultTokenAccount,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
    })
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    const optimisticResult = {
        hadespinRakeback: Object.assign(Object.assign({}, optimistic.hadespinRakeback), { claimed: true, claimedAt: (0, perpetual_1.nowInSeconds)(), lastTransactedAt: (0, perpetual_1.nowInSeconds)() }),
    };
    return {
        instructions,
        signers,
        optimisticResult,
    };
});
exports.claimUserRakeback = claimUserRakeback;
